import React from "react";
import { useTranslation } from "react-i18next";
import ConvertToString from "../../../components/Converter";
import Millimetre from "../../../components/Math/Units/Metric/Millimetre";
import { RowBody } from "../../../components/RowValue/RowBody";

function HollowBarDiameter({ duchmesserTragglied }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("inner.verificationCapacity.hollowBarDiameter")}</p>}
      indicesValue={
        <span>
          D<sub>a</sub>
        </span>
      }
      inputValue={<span className="input">{ConvertToString(duchmesserTragglied)}</span>}
      unitValue={<Millimetre />}
    />
  );
}

export default HollowBarDiameter;
